<template>
    <div class="bg-white">
        <CTabs variant="pills">
              <CTab title="Member Approval" active>
                <CCol sm="12" lg="12" class="mx-auto" style="width: 100%; background-size: cover; color: #000;">
                <h3 class="custom-24px-500 text-left mt-4">Member Approval</h3>
                <h4 class="custom-16px-500 text-left font-color-AEAEB2">Review and approve membership requests to ensure only eligible members join the club</h4>
                <div class="table-container" style="overflow-x:auto; max-width: 100%;">
                        <table class="table table-responsive-sm mt-4">
                            <thead>
                                <th>Club Name</th>
                                <th>Name</th>
                                <th>Phone Number</th>
                                
                                <th>Email</th>
                                <th>Submission Date</th>
                                <th></th>
                            </thead>
                            <tbody v-for="(item, index) in member" :key="item.Id">
                                <tr>
                                    <td>{{ item.teamName }}</td>
                                    <td>{{ item.user }}</td>
                                    <td>{{ item.phone  }}</td>
                                    <td>{{ item.email }}</td>
                                    <td>{{ item.createdDate | moment("MMMM DD, YYYY") }}</td>
                                    <td>
                                        <div class="d-flex">
                                            <CButton type="button" class="bg-064BB4 border-10px text-white" @click="openDetail(item)"><img src="../assets/img/tick-circle.png" width="20px" class="mr-2"/>Approve</CButton>
                                            <CButton type="button" class="bg-FEF3F2 font-color-F04438 ml-2" @click="openDetail(item)"><img src="../assets/img/close-circle.png" width="20px" class="mr-2"/>Reject</CButton>
                                        </div></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
              </CTab>
              <CTab title="Member List">
                <CCol sm="12" lg="12" class="mx-auto" style="width: 100%; background-size: cover; color: #000;">
                <h3 class="custom-24px-500 text-left mt-4">Member List</h3>
                <h4 class="custom-16px-500 text-left font-color-AEAEB2">View and manage a comprehensive list of all club members with their details and status.</h4>
                <div class="table-container" style="overflow-x:auto; max-width: 100%;">
                        <table class="table table-responsive-sm mt-4">
                            <thead>
                                <th>Club Name</th>
                                <th>Name</th>
                                <th>Phone Number</th>
                                
                                <th>Email</th>
                                <th>Submission Date</th>
                                <th>Status</th>
                                <th></th>
                            </thead>
                            <tbody v-for="(item, index) in confirm" :key="item.Id">
                                <tr>
                                    <td>{{ item.teamName }}</td>
                                    <td>{{ item.user }}</td>
                                    <td>{{ item.phone  }}</td>
                                    <td>{{ item.email }}</td>
                                    <td>{{ item.createdDate | moment("MMMM DD, YYYY") }}</td>
                                    <td>
                                        <div class="d-flex">
                                            <CButton type="button" class="bg-ECFDF3 border-10px font-color-12B76A" v-if="item.statusApprover == 1">Approved</CButton>
                                            <CButton type="button" class="bg-FEF3F2 font-color-F04438 ml-2" v-else>Rejected</CButton>
                                        </div>
                                    </td>
                                    <td>
                                        <img src="../assets/img/icon-main/iconedit.png" width="20px" class="mr-2" @click="openDetail(item)"/>
                                        <!-- <img src="../assets/img/icon-main/Delete.png" width="20px" /> -->
                                        </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
               
              </CTab>
        </CTabs>

        <div v-if="isPopupUpdateStatus" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                   <CRow>
                    <CCol sm="2">
                        <div class="text-left">
                            <img src="../assets/img/defaultteam.png" style="max-width:100%"/>
                        </div>
                    </CCol>
                    <CCol sm="8">
                        <div class="text-left">
                            <h4 class="custom-18px-500 font-color-0A0A0A">{{ detail.teamName}}</h4>
                            <p class="custom-16px-500 font-color-98A2B3">{{ detail.category}}</p>
                        </div>
                    </CCol>
                    <CCol sm="2"></CCol>
                   </CRow>
                    
                    <CRow>
                        <CCol sm="12">
                            <div class="text-left mt-3">
                                <h3 class="custom-16px-400 color-dark-grey">Name</h3>
                                <h4 class="custom-18px-500 font-color-0A0A0A">{{ detail.user}}</h4>
                                <hr class="custom-hr"/>

                                <h3 class="custom-16px-400 color-dark-grey">Phone Number</h3>
                                <h4 class="custom-18px-500 font-color-0A0A0A">{{ detail.phone}}</h4>
                                <hr class="custom-hr"/>

                                <h3 class="custom-16px-400 color-dark-grey">Email</h3>
                                <h4 class="custom-18px-500 font-color-0A0A0A">{{ detail.email}}</h4>
                                <hr class="custom-hr"/>

                                <h3 class="custom-16px-400 color-dark-grey">Submission Date</h3>
                                <h4 class="custom-18px-500 font-color-0A0A0A">{{ detail.createdDate}}</h4>
                                <hr class="custom-hr"/>
                            </div>
                        </CCol>
                        <CCol sm="6"><CButton type="button" class="bg-064BB4 border-10px text-white" block @click="SubmitApprove(detail.user_id, detail.teamId)"><img src="../assets/img/tick-circle.png" width="20px" class="mr-2"/>Approve</CButton></CCol>
                        <CCol sm="6"><CButton type="button" class="bg-FEF3F2 font-color-F04438 ml-2" block @click="SubmitReject(detail.user_id,detail.teamId)"><img src="../assets/img/close-circle.png" width="20px" class="mr-2"/>Reject</CButton></CCol>
                            
                    </CRow>
                
                </div>
            </div>
        </div>

     

        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 100px" src="../assets/img/success.png" />
                        <h3 class="custom-18px-400 font-color-171717 text-center mt-3">
                            Your data save successfully
                        </h3>
                        <CButton class="custom-bg-border-AEAEB2" @click="closeSuccess" style="width:100px">
                            <span class="ml-2 mr-2">OK</span>
                        </CButton>
                    </div>
                </div>
            </div>

    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/Membership.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bg.png";

import Mainlayout from "../containers/HeaderLogin.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

import msalInstance from '../containers/msalService';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },
    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,

            backgroundGenie,
            user: {},
            member: [],
            isPopupSuccess: false,
            chosen:{},
            isPopupUpdateStatus: false,
            detail: {},
            confirm: []
        
            

           



        };
    },
  
    created() {
        AOS.init();

    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                await this.GetChosenTeam();
                await this.GetConfirmTeam();
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    this.filePath = response.data.filePath;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.Name = this.info.name;
                        this.Phone = this.info.phone;
                        this.Email = this.info.email;
                        this.UserId = this.info.id;
                        this.filePath = this.info.filePath;
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetChosenTeam() {
            this.$API
                .get(this.$GetListPendingChosenTeam, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.member = response.data;
                    }
                });
        },
        openDetail(item)
        {
            this.GetChosenTeamById(item.id);
            this.isPopupUpdateStatus = true;

        },
        async GetChosenTeamById(id) {
            this.$API
                .get(this.$GetListPendingChosenTeamById + "?id=" + id, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.detail = response.data;
                    }
                });
        },
        SubmitApprove(userid,teamid)
        {
           
            const formData = new FormData();
        
            formData.append("UserId", userid);
            formData.append("ClubId", teamid);
            formData.append("StatusChosen", 1);


            return this.$API
            .post(this.$InsertChooseTeam, formData, {
                withCredentials: true,
            })
            .then((response) => {
                if (response.status == 200 && response.data != null) {
                    this.GetChosenTeam();
                    this.GetConfirmTeam();
                    this.isPopupUpdateStatus = false;
                    this.isPopupSuccess = true;
                   
                
                
                }
            })
            .catch((error) => {
                if (error.response) {
                console.log(error.response.status);
                this.Error = true;
                this.Message = error;
                this.Message = "Error";
                }
            });
        },
        SubmitReject(userid,teamid)
        {
           
            const formData = new FormData();
        
            formData.append("UserId", userid);
            formData.append("ClubId", teamid);
            formData.append("StatusChosen", 3);


            return this.$API
            .post(this.$InsertChooseTeam, formData, {
                withCredentials: true,
            })
            .then((response) => {
                if (response.status == 200 && response.data != null) {
                    this.GetChosenTeam();
                    this.GetConfirmTeam();
                    this.isPopupUpdateStatus = false;
                    this.isPopupSuccess = true;
                }
            })
            .catch((error) => {
                if (error.response) {
                console.log(error.response.status);
                this.Error = true;
                this.Message = error;
                this.Message = "Error";
                }
            });
        },
        closeSuccess()
        {
            this.isPopupSuccess = false;
        },

        async GetConfirmTeam() {
            this.$API
                .get(this.$GetListConfirmChosenTeam, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.confirm = response.data;
                    }
                });
        },
        
       
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/loginaccount") {

                this.$router.push({
                path: '/LoginAccount',
                query: {
                    targetUrl: this.$router.currentRoute.fullPath,
                }
                })

            }
        },
    }



};
</script>